import { c as _c } from "react/compiler-runtime";
import { type Api, lookup } from '@cruz-com/lookup';
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';
import { RadioButtons, Separator } from '@/components';
import { abbNumber } from '@/lib';
type Props = {
  meta: Api.Meta;
  pageSize?: number;
  className?: string;
  onPageSizeChanged?: (val: number) => void;
} & React.ComponentPropsWithoutRef<'span'>;
export function PageMeta(t0) {
  const $ = _c(26);
  const {
    meta,
    pageSize,
    className,
    onPageSizeChanged
  } = t0;
  if (_.isEmpty(meta) || !meta.total_records_matched) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const start = Math.min(meta.total_records_matched, ((meta?.page_number || 1) - 1) * (pageSize || 12) + 1);
  const end = Math.min(meta?.total_records_matched || 0, start - 1 + (pageSize || 12));
  let t1;
  if ($[1] !== className) {
    t1 = twMerge("flex gap-x-1 py-1 text-base/6 font-light md:text-sm/6", className);
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== start) {
    t2 = start.toLocaleString();
    $[3] = start;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="font-medium">{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== end) {
    t4 = end.toLocaleString();
    $[7] = end;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="font-medium">{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = meta?.total_records_matched;
  let t7;
  if ($[11] !== t6) {
    t7 = abbNumber(t6, 2);
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <span className="font-medium">{t7}</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5 || $[18] !== t8) {
    t9 = <div aria-live="polite" aria-atomic="true"><div className={t1}>Showing {t3}to {t5}of {t8}results</div></div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onPageSizeChanged || $[21] !== pageSize) {
    t10 = pageSize && onPageSizeChanged && <><Separator className="hidden sm:block" /><div className="flex items-center gap-x-3"><div className="vehicle-s2-label" aria-hidden="true">Page Size:</div><RadioButtons aria-label="Select Page Size" name="page_size" option={lookup.other.pageSizeOption} value={_.toNumber(pageSize)} onChange={val => {
          onPageSizeChanged(_.toNumber(val));
        }} /></div></>;
    $[20] = onPageSizeChanged;
    $[21] = pageSize;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <section aria-label="Pagination Summary" className="flex flex-col gap-3 sm:flex-row sm:items-center">{t9}{t10}</section>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}